import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  DirectionsEditRouteComponent, type DirectionsPanelEditProps,
} from './directionsEditRoute.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    DirectionsEditRoute: DirectionsPanelEditProps;
  }
}
modalRenderer.register('DirectionsEditRoute', DirectionsEditRouteComponent);
